/*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/
import { NETPOSITION,  NET_POSITION_INFO } from "../actionTypes";
const initialState = {
    netPositionGridData: [],
    activewatchlistPosition: [],
    extendorders: [],
    todaysPostions: [],
    overAllPositions: [],
    todaysPandL: [],
    overAllPandL: [],
    active: [],
    overAllInterOpOff: [],
    todaysInterOpOff: [],
    squareOffAllEnabled: false,
    //Ameersha N: 7-09-2023 : BT-96552 - Breeze - Manage Columns -Start
    netPositionColdef: [],
    //Ameersha N: 7-09-2023 : BT-96552 - Breeze - Manage Columns - End
    //Mahesh S : 09-11-2023 : BT-102298 NSECDS Netposition – netposition column def changes – Start */}
    arrNetPositionColumnDefs: [],
    //Mahesh S : 09-11-2023 : BT-102298 NSECDS Netposition – netposition column def changes – End */}
    // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – Start 
    objTodaysPositionsIndexes: {},
    objOverAllPositionsIndexes: {},
    bIsNetPositionApiPending: false,
    // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – End 
    bIsCovertOrSquareOffPositionApiPending: false
};

const netPositionReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case NET_POSITION_INFO?.UPDATE_NETPOSITION_COL_DEF:
            return {
                ...state,
                netPositionColdef: actions?.payload
            };
        case NET_POSITION_INFO.UPDATE_OVERALL_POSITIONS:
            return {
                ...state,
                overAllPositions: actions.payload
            };
        case NET_POSITION_INFO.UPDATE_TODAYS_POSITIONS:
            return {
                ...state,
                todaysPostions: actions.payload
            };
        case NETPOSITION.UPDATE_ACTIVE_NET_POSITION:
            return {
                ...state,
                active: actions.payload
            };
        case NETPOSITION.UPDATE_TODAY_PL:
            return { ...state, todaysPandL: actions.payload };
        case NETPOSITION.UPDATE_OVERALL_PL:
            return { ...state, overAllPandL: actions.payload };

        case NETPOSITION.CONVERT_POSITION_SUCCESS:
            return { ...state, objConvertPosition: actions.payload };
        case NETPOSITION.CONVERT_POSITION_FAILURE:
            return { ...state, objConvertPosition: actions.payload };

        case NETPOSITION.SQUAREOFF_POSITION_SUCCESS:
            return { ...state, objSquareOffPositions: actions.payload };
        case NETPOSITION.SQUAREOFF_POSITION_FAILURE:
            return { ...state, objSquareOffPositions: actions.payload };

        case NET_POSITION_INFO.UPDATE_INTEROP_TODAYS_POSITIONS:
            return { ...state, todaysInterOpOff: actions.payload };
        case NET_POSITION_INFO.UPDATE_INTEROP_OVERALL_POSITIONS:
            return { ...state, overAllInterOpOff: actions.payload };
        case NETPOSITION.UPDATE_IS_SQUARE_OFF:
            return { ...state, squareOffAllEnabled: actions.payload };
            // {/* Mahesh S : 09-11-2023 : BT-102298 NSECDS Netposition – netposition column def changes – Start */ }
        case NETPOSITION.GET_NETPOSITION_COLUMNDEF_SUCCESS:
            return { ...state, arrNetPositionColumnDefs: actions.payload };
        case NETPOSITION.GET_NETPOSITION_COLUMNDEF_FAILURE:
            return { ...state, arrNetPositionColumnDefs: actions.payload };
            // {/* Mahesh S : 09-11-2023 : BT-102298 NSECDS Netposition – netposition column def changes – End */ }
        // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – Start 

        case NET_POSITION_INFO.UPDATE_TODAYS_POSITIONS_INDEXES:
            return {
                ...state,
                objTodaysPositionsIndexes: actions.payload
            };
        case NET_POSITION_INFO.UPDATE_OVERALL_POSITIONS_INDEXES:
            return {
                ...state,
                objOverAllPositionsIndexes: actions.payload
            };
        case NET_POSITION_INFO.NET_POSITION_API_PENDING:
            return {
                ...state,
                bIsNetPositionApiPending: actions.payload
            };
        case NETPOSITION.CONVERT_OR_SQUAREOFF_POSITION_API_PENDING:
            return {
                ...state,
                bIsCovertOrSquareOffPositionApiPending: actions.payload
            };
        // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – End 
        default:
            return state;
    }

};

export default netPositionReducer;

/*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - End*/
